import { z } from '@harvestiq/zod';

/**
 * Normalizes color values.
 * Supports:
 * - Hex colors: #RRGGBB (e.g., #AC141C, AC141C)
 * - HSL colors: hsl(H, S%, L%) (e.g., hsl(120, 54.02%, 24.12%))
 */
const colorSchema = z
  .string()
  .trim()
  .transform((val) => {
    // If it's HSL, normalize by removing extra spaces
    if (val.toLowerCase().startsWith('hsl(')) {
      // Remove all spaces within the hsl() function
      return val.replace(/\s+/g, '');
    }

    // If it's hex, normalize to uppercase with #
    const normalized = val.startsWith('#') ? val : `#${val}`;
    return normalized.toUpperCase();
  });

export const colorSchemeSchema = z.object({
  primary: colorSchema,
  secondary: colorSchema,
  success: colorSchema,
  info: colorSchema,
  warning: colorSchema,
  error: colorSchema,
});

export type ColorScheme = z.infer<typeof colorSchemeSchema>;

export const defaultColorScheme: ColorScheme = {
  primary: '#AC141C',
  secondary: '#EF767A',
  success: '#49DCB1',
  info: '#445699',
  warning: '#EEB868',
  error: '#AC141C',
};

export const colorSchemeKeys = Object.keys(
  defaultColorScheme
) as (keyof ColorScheme)[];
